import { Box, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const Branding = ({ onClose }) => {
  const handleReload = () => {
    window.location.href = "/";  // Redirect to homepage
  }
  
  const handleBack = () => {
    onClose();
  }

  return (
    <Box sx={{ p: 2, pb: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box
        component="a"
        onClick={handleReload}
        sx={{
          width: '35%', height: 'auto', cursor: 'pointer',
          display: 'flex', alignItems: 'center'
        }}
      >
        <img
          src="/assets/logo-red-(512x110).png"
          alt="logo"
          style={{ width: '100%', height: 'auto' }}
        />
      </Box>

      <IconButton
        color="inherit"
        onClick={handleBack}
        aria-label="Go back"
      >
        <ArrowBack />
      </IconButton>
    </Box>
  );
};

export default Branding;
